import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import "./categorias.css";

const url = "https://api.mrcirp.com/public/usuarios";
const urlAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";
const urldelete = "https://api.mrcirp.com/public/usuariosdelete";
const urleditar = "https://api.mrcirp.com/public/usuariosedit";

const Categorias = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);
  const [dataAudiencia, setDataAudiencia] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    usuario: "",
    descripcion: "",
    urlvideo: "",
    urlvideoproducto1: "",
    urlvideoproducto2: "",
    urlvideoproducto3: "",
    urlnegocio1: "",
    urlnegocio2: "",
    urlnegocio3: "",
    urlcomounirsecliente: "",
    urlcomoafiliarse: "",
    fecha: "",
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  // Columnas para campañas de video
  const columnsVideo = [
    {
      name: "Acción",
      button: true,
      width: "140px",
      cell: (row) => (
        <div className="modern-action-buttons">
          <button
            onClick={() => {
              window.open(`http://app.mrcirp.com/${row.usuario}`, "_blank");
            }}
            className="modern-action-btn view"
            title="Ver Landing de Video"
          >
            <FaIcons.FaEye />
          </button>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditaruser();
            }}
            className="modern-action-btn lock"
            title="Editar Usuario"
          >
            <FaIcons.FaRegEdit />
          </button>
          <button
            className="modern-action-btn delete"
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditar();
            }}
            title="Eliminar Usuario"
          >
            <FaIcons.FaTrash />
          </button>
        </div>
      ),
    },
    {
      name: "ID",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
      width: "60px",
    },
    {
      name: "Nombre de Campaña",
      selector: (row) => row.nombrecampana,
      width: "150px",
      wrap: true,
    },
    {
      name: "Enlace",
      selector: (row) => row.usuario,
      width: "120px",
    },
    {
      name: "Descripción",
      selector: (row) => row.descripcion,
      width: "200px",
      wrap: true,
    },
    {
      name: "Fecha",
      selector: (row) => row.fecha,
      width: "100px",
    },
    {
      name: "Creador",
      selector: (row) => row.nombrecreador,
      width: "120px",
    },
  ];

  // Columnas para campañas de audiencia
  const columnsAudiencia = [
    {
      name: "Acción",
      button: true,
      width: "100px",
      cell: (row) => (
        <div className="modern-action-buttons">
          <button
            onClick={() => {
              window.open(`https://apptest.mrcirp.com/audiencia/${row.enlace_campana}`, "_blank");
            }}
            className="modern-action-btn edit"
            title="Ver Landing de Audiencia"
          >
            <FaIcons.FaEye />
          </button>
          <button
            className="modern-action-btn delete"
            onClick={() => {
              // Aquí puedes agregar lógica para eliminar campaña de audiencia
              alert("Funcionalidad de eliminar campaña de audiencia pendiente");
            }}
            title="Eliminar Campaña"
          >
            <FaIcons.FaTrash />
          </button>
        </div>
      ),
    },
    {
      name: "ID",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
      width: "60px",
    },
    {
      name: "Nombre de Campaña",
      selector: (row) => row.nombre_campana,
      width: "150px",
      wrap: true,
    },
    {
      name: "Enlace",
      selector: (row) => row.enlace_campana,
      width: "120px",
    },
    {
      name: "Descripción",
      selector: (row) => row.descripcion,
      width: "200px",
      wrap: true,
    },
    {
      name: "Fecha Creación",
      selector: (row) => row.fecha_creacion,
      width: "120px",
    },
    {
      name: "Creador",
      selector: (row) => row.admin_nombre,
      width: "120px",
    },
  ];
  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);
  const [buscarAudiencia, setBuscarAudiencia] = useState("");
  const [filtrobuscarAudiencia, setFiltroBuscarAudiencia] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = data.filter((resultdata) => {
      if (
        resultdata.usuario.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.descripcion.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.nombrecampana.toLowerCase().match(buscar.toLowerCase())
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = dataAudiencia.filter((resultdata) => {
      if (
        resultdata.enlace_campana.toLowerCase().match(buscarAudiencia.toLowerCase()) ||
        resultdata.descripcion.toLowerCase().match(buscarAudiencia.toLowerCase()) ||
        resultdata.nombre_campana.toLowerCase().match(buscarAudiencia.toLowerCase())
      ) {
        return resultdata;
      }
    });
    setFiltroBuscarAudiencia(result);
  }, [buscarAudiencia, dataAudiencia]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    // eslint-disable-next-line no-template-curly-in-string
    await axios
      .delete(urldelete + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditar(false);
      })
      .catch((err) => {
        setError(true);
        setModalEditar(false);
      });
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(urleditar + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    await axios.get(url).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
    });
  };

  const peticionGetAudiencia = async () => {
    await axios.get(urlAudiencia).then((response) => {
      setDataAudiencia(response.data);
      setFiltroBuscarAudiencia(response.data);
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    await peticionGet();
    await peticionGetAudiencia();
  }, []);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <Sidebar>
        <div className="mislanding-container">
          <div className="Categorias">
          
              <Card className="modern-card">
                <Card.Header className="modern-card-header" as="h3">
                  <div className="row">
                    <div className="col-md-12">🎯 Gestión de Campañas</div>
                  </div>
                </Card.Header>
                <Card.Body className="modern-card-body">
                  <h2 className="modern-title">Administración de Campañas</h2>
                  <p className="modern-subtitle">Gestiona campañas de video y audiencia por separado</p>
                  {Error && (
                    <div className="modern-alert modern-alert-danger">
                      <strong>
                        Error: El nombre ya existe! intente con otro nombre.
                      </strong>
                    </div>
                  )}
                  <Tab.Container defaultActiveKey="video">
                    <Nav variant="tabs" className="modern-tabs">
                      <Nav.Item>
                        <Nav.Link eventKey="video" className="modern-tab-link">
                          <FaIcons.FaVideo className="me-2" />
                          Campañas de Video ({filtrobuscar.length})
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="audiencia" className="modern-tab-link">
                          <FaIcons.FaUsers className="me-2" />
                          Campañas de Audiencia ({filtrobuscarAudiencia.length})
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content>
                      <Tab.Pane eventKey="video">
                        <div className="modern-datatable">
                          <DataTable
                            columns={columnsVideo}
                            data={filtrobuscar}
                            noDataComponent="No hay campañas de video registradas"
                            progressPending={pending}
                            progressComponent={<Cargando />}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            subHeader
                            subHeaderComponent={
                              <div className="modern-search-container">
                                <input
                                  type="text"
                                  placeholder="Buscar campañas de video..."
                                  className="modern-search-input"
                                  value={buscar}
                                  onChange={(e) => setBuscar(e.target.value)}
                                />
                                <FaIcons.FaSearch className="modern-search-icon" />
                              </div>
                            }
                            responsive
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            scrollX
                            scrollY
                          />
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="audiencia">
                        <div className="modern-datatable">
                          <DataTable
                            columns={columnsAudiencia}
                            data={filtrobuscarAudiencia}
                            noDataComponent="No hay campañas de audiencia registradas"
                            progressPending={pending}
                            progressComponent={<Cargando />}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            subHeader
                            subHeaderComponent={
                              <div className="modern-search-container">
                                <input
                                  type="text"
                                  placeholder="Buscar campañas de audiencia..."
                                  className="modern-search-input"
                                  value={buscarAudiencia}
                                  onChange={(e) => setBuscarAudiencia(e.target.value)}
                                />
                                <FaIcons.FaSearch className="modern-search-icon" />
                              </div>
                            }
                            responsive
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            scrollX
                            scrollY
                          />
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>

                  <Modal isOpen={modalEditar} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h4 className="modern-modal-title">Eliminar usuario </h4>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <input
                        className="modern-form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="modern-form-group">
                        <h5 style={{color: "#2d3748", marginBottom: "16px"}}>
                          ¿Desea eliminar al usuario #{datosSeleccionados.id}?{" "}
                        </h5>
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-danger"
                        onClick={() => peticionPut()}
                      >
                        Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h5 className="modern-modal-title">Editar usuario {datosSeleccionados.username}</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <div className="modern-form-group">
                        <input
                          className="modern-form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label className="modern-form-label">Descripción de la campaña</label>
                        <textarea
                          className="modern-form-control"
                          name="descripcion"
                          value={datosSeleccionados.descripcion}
                          onChange={handleChange}
                          maxLength="150"
                          rows="3"
                        />
                        
                        <label className="modern-form-label">URL video</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideo"
                          value={datosSeleccionados.urlvideo}
                          onChange={handleChange}
                        />
                        
                        <label className="modern-form-label">URL Zona de revelación 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto1"
                          value={datosSeleccionados.urlvideoproducto1}
                          onChange={handleChange}
                        />
                     
                        <label className="modern-form-label">URL Zona de revelación 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto2"
                          value={datosSeleccionados.urlvideoproducto2}
                          onChange={handleChange}
                        />
                     
                        <label className="modern-form-label">URL Zona de revelación 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto3"
                          value={datosSeleccionados.urlvideoproducto3}
                          onChange={handleChange}
                        />
                        
                        <label className="modern-form-label">URL como unirse como cliente</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomounirsecliente"
                          value={datosSeleccionados.urlcomounirsecliente}
                          onChange={handleChange}
                        />
                        
                         
                        <label className="modern-form-label">URL Botón Zona de revelación</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonProducto"
                          value={datosSeleccionados.urlBotonProducto}
                          onChange={handleChange}
                        />
                       
                        <label className="modern-form-label">URL Zona de éxito 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio1"
                          value={datosSeleccionados.urlnegocio1}
                          onChange={handleChange}
                        />
                        
                        <label className="modern-form-label">URL Zona de éxito 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio2"
                          value={datosSeleccionados.urlnegocio2}
                          onChange={handleChange}
                        />
                        
                        <label className="modern-form-label">URL Zona de éxito 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio3"
                          value={datosSeleccionados.urlnegocio3}
                          onChange={handleChange}
                        />
                      
                        <label className="modern-form-label">URL como afiliarse</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomoafiliarse"
                          value={datosSeleccionados.urlcomoafiliarse}
                          onChange={handleChange}
                        />
                      
                        <label className="modern-form-label">URL botón Zona de éxito</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonNegocio"
                          value={datosSeleccionados.urlBotonNegocio}
                          onChange={handleChange}
                        />
                        
                     
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-primary"
                        onClick={() => peticionPutuser()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
           
          </div>
        </div>
        </Sidebar>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Categorias;